import { styled } from '@/stitches.config';

export const TextField = styled('input', {
  all: 'unset',
  ap: 'none',
  boxSizing: 'border-box',
  border: 'none',
  outline: 'none',
  m: 0,
  p: 0,
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  width: '100%',
  height: 48,
  px: '$4',
  br: '$rounded-1-5',
  bs: 'inset 0px 0px 0px 1px $gray400',
  bc: '$white',
  transitionProperty: 'box-shadow, background-color, color',
  transitionDuration: '0.4s',
  transitionTimingFunction: 'cubic-bezier(0.25, 0.74, 0.22, 0.99)',
  color: '$black',
  fontFamily: '$regular',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '48px',
  whiteSpace: 'nowrap',
  '&::before, &::after': {
    boxSizing: 'border-box',
  },
  '&:focus': {
    bs: 'inset 0px 0px 0px 1px $gray1000',
    '&:-webkit-autofill': {
      bs: 'inset 0px 0px 0px 1px $gray1000, inset 0px 0px 0px 1000px $white',
    },
  },
  '&:-webkit-autofill': {
    bs: 'inset 0px 0px 0px 1px $gray400, inset 0px 0px 0px 1000px $white',
    '&::first-line': {
      color: '$black',
    },
  },
  '&::placeholder': {
    color: '$gray600',
  },
  '&:read-only': {
    bc: '$white',
    '&:focus': {
      bs: 'inset 0px 0px 0px 1px $gray400',
    },
  },
  '&:disabled': {
    opacity: '1',
    pe: 'none',
    bc: '$gray200',
    bs: 'inset 0px 0px 0px 1px $gray300',
    color: '$gray600',
    cursor: 'not-allowed',
    us: 'none',
    '&::placeholder': {
      color: '$gray600',
    },
  },
  '&.is-error': {
    bs: 'inset 0px 0px 0px 1px $primary',
    '&::placeholder': {},
  },
});

export const TextFieldIcon = styled('div', {
  position: 'absolute',
  left: 0,
  top: 0,
  p: '$3',
  pe: 'none',
  fontSize: '0',
  [`& + ${TextField}`]: {
    pl: '$11',
  },
});

export const TextFieldWrapper = styled('div', {
  position: 'relative',
  height: 48,
});
